<template>
  <va-card :title="$t('menu.load_flow')">
    <div class="row">
      <div class="flex xs12 sm3">
        <va-button v-if="ability.can('create', 'LoadSteps')"
          medium
          inline
          color="secondary"
          icon="fa fa-plus"
          class="ma-0"
          :to="{ name: 'form-load-flow' }"
        >
          {{ $t('menu.new') }}
        </va-button>
      </div>
    </div>
    
    <va-data-table
      :fields="fields"
      :data="load_steps"
      :per-page="15"
    >
      <template slot="actions" slot-scope="props">
        <va-button v-if="ability.can('update', 'LoadSteps')"
            small
            inline
            color="green"
            icon="fa fa-edit"
            class="mr-1"
            :to="{ name: 'form-load-flow', params: { load_step_id: props.rowData.id } }" 
          >
            {{ $t('menu.edit') }}
        </va-button>

        <va-button v-if="ability.can('destroy', 'LoadSteps')"
          small 
          inline 
          color="danger" 
          icon="fa fa-remove"
          class="ma-0"
          @click="showModalRemove = true, loadStepId = props.rowData.id" 
        >
          {{ $t('tables.delete') }}
        </va-button>
      </template>
      </va-data-table>
        <va-modal
          v-model="showModalRemove"
          size="small"
          :title="$t('modal.remove')"
          :message="$t('modal.genericConfirmMessage')"
          hideDefaultActions
          :color="this.$themes.secondary"
        >
        <va-button
          color="danger"
          class="ma-2"
          @click="showModalRemove = false">
          {{$t('modal.cancel')}}
        </va-button>

        <va-button
          color="green"
          class="ma-2"
          @click="remove(loadStepId), showModalRemove = false">
          {{$t('modal.confirm')}}
        </va-button>
      </va-modal>
  </va-card>
</template>

<script>

import LoadStepAPI from '@/services/LoadStepAPI'
import { mapState } from "vuex";
import { Ability } from '@casl/ability'
export const ability = new Ability()

export default {
  data () {
    return {
      data: [],
      ability: [],
      load_steps: [],
      showModalRemove: false,
      loadStepId: ''
    }
  },

  beforeMount () {
    this.ability = ability.update(this.rules)
  },

  mounted () {
    this.getAllLoadSteps()
  },

  methods: {
    remove (loadStatus) {
      LoadStepAPI.remove(loadStatus).then(response => {
        const rowItem = this.data.map((e) => e.id).indexOf(loadStatus)
        this.data.splice(rowItem, 1)

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.getAllLoadSteps()
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },

    getAllLoadSteps () {
      LoadStepAPI.getAllLoadSteps().then(response => {
        this.load_steps = response.data.load_steps
      })
    }
  },

  computed: {
    ...mapState(['rules']),

    fields () {
      return [
        {
          name: 'id',
          title: this.$t('tables.mounting_flow.id'),
          width: '10%',
        },
        {
          name: 'step_sequence',
          title: this.$t('tables.mounting_flow.step_sequence'),
          width: '10%',
        },
        {
          name: 'status',
          title: this.$t('tables.mounting_flow.status'),
          width: '20%',
        },
        {
          name: 'role',
          title: this.$t('tables.mounting_flow.role'),
          width: '30%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
      },
    },
}
</script>